"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveDrillToAttributeUrl = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var effects_1 = require("redux-saga/effects");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var sdk_model_1 = require("@gooddata/sdk-model");
var getElementTitle_1 = require("./getElementTitle");
function getDrillToAttributeUrlIntersectionAttributeItemHeader(drillConfig, event) {
    var _a;
    return (_a = event.drillContext.intersection.find(function (item) {
        return sdk_ui_1.isDrillIntersectionAttributeItem(item.header) &&
            sdk_model_1.areObjRefsEqual(item.header.attributeHeader.ref, drillConfig.target.displayForm);
    })) === null || _a === void 0 ? void 0 : _a.header;
}
function resolveDrillToAttributeUrl(drillConfig, event, ctx) {
    var header, url;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                header = getDrillToAttributeUrlIntersectionAttributeItemHeader(drillConfig, event);
                if (!header) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, effects_1.call(getElementTitle_1.getElementTitle, ctx.workspace, drillConfig.target.hyperlinkDisplayForm, header.attributeHeaderItem.uri, ctx)];
            case 1:
                url = _a.sent();
                return [2 /*return*/, url];
        }
    });
}
exports.resolveDrillToAttributeUrl = resolveDrillToAttributeUrl;
//# sourceMappingURL=resolveDrillToAttributeUrl.js.map